<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import ArticlesSection from "@components/sections/ArticlesSection.svelte";
	import CaseStudiesSection from "@components/sections/CaseStudiesSection.svelte";
	import HeroSection from "@components/sections/HeroSection.svelte";
	import NewsletterSection from "@components/sections/NewsletterSection.svelte";
	import PartnersSection from "@components/sections/PartnersSection.svelte";
	import ProductsSection from "@components/sections/ProductsSection.svelte";
	import ReviewSection from "@components/sections/ReviewSection.svelte";
	import ServicesSection from "@components/sections/ServicesSection.svelte";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import type { HomepageProps } from "./HomepageProps.js";

	const { articles, caseStudies, partners, products, reviews, mainCaseStudy }: HomepageProps = $props();
	const { FF_SHOW_PRODUCTS } = getGlobalSettings();
</script>

<Layout>
	<HeroSection />
	<ReviewSection {reviews} />
	<ServicesSection />
	<CaseStudiesSection {caseStudies} {mainCaseStudy} />
	<PartnersSection {partners} />
	{#if FF_SHOW_PRODUCTS === "true"}
		<ProductsSection {products} />
	{/if}
	<NewsletterSection />
	<ArticlesSection {articles} />
</Layout>
